<template>
    <div>
        <ul>
            <li v-for="child in children" track-by="$index">
                <routes-list v-if="child.children" :item="child"></routes-list>
                <span v-else>
                    Name: {{child.name}}<br>
                    URL: {{child.path}}
                </span>
            </li>
        </ul>
    </div>
</template>

<script>
import RoutesList from './RoutesList';
export default {
    components: {
        RoutesList
    },
    name: 'routesListItems',
    props: ['children']
};
</script>



// WEBPACK FOOTER //
// src/views/Debug/Routes/RoutesListItems.vue